import { Skeleton, Card, CardContent, Container  } from "@material-ui/core";
import { Box } from "@material-ui/system";

const CardLoader = ({ rowsNum, height }) => {
	return <>
		{
			[...Array(rowsNum)].map((index) => (
				<Container>
				<Card key={index} sx={{mt:2, mx:1}}>
					<CardContent>
						<Box sx={{alignItems: 'flex-start', mt:-10}}>
						<Skeleton animation="wave" variant="text" height={height}/>
						<Skeleton animation="wave" variant="text"/>
						<Skeleton animation="wave" variant="text" />
						<Skeleton animation="wave" variant="text" />
						</Box>
						</CardContent>
					
				</Card>
				</Container>
			))
		}
	</>
};

export default CardLoader;